import * as Onboarding from '../_layout/OnboardingComponents'
import { InvestorAnalysisContent } from '../investor-analysis/_layout/InvestorAnalysisContent'
import { InvestorAnalysisSideMenu } from '../investor-analysis/_layout/InvestorAnalysisSideMenu'

function InvestorAnalysisPage() {
  return (
    <Onboarding.Container>
      <Onboarding.ContainerContent>
        <InvestorAnalysisContent />
      </Onboarding.ContainerContent>

      <Onboarding.ContainerSideMenu>
        <InvestorAnalysisSideMenu />
      </Onboarding.ContainerSideMenu>
    </Onboarding.Container>
  )
}

export default InvestorAnalysisPage
